import restApis from "../apis/rest";
import {WWUtils,wwConstants} from "./index";
import {message} from "antd";
import AlarmStatisticsSummary from "../containers/Statistics/components/ForkliftStatisticsSummary";
import ForkliftStatisticsSummary from "../containers/Statistics/components/ForkliftStatisticsSummary";
import ForkliftStatisticsDetail from "../containers/Statistics/components/ForkliftStatisticsDetail";


export default class WWMethods{
    constructor() {
    }
    /**
     * session过期跳转
     */
    static toLoginPageForSessionExpired(response) {
        var chgPwd = response.headers.get('reason');
        console.log(response.headers.get('reason')) // CHANGE_PASSWORD
        if (chgPwd && chgPwd == "CHANGE_PASSWORD") {
            this.logout(false);
        } else {
            this.logout(true);
        }

    }
    /**
     * 登出
     */
    static logout(isNormal) {
        let path = this.getApiUrl("logout");
        this.delCookie('USER_TOKEN');
        this.delCookie('username');
        this.delCookie('BMAP_SECKEY');
        localStorage.removeItem("setTabActiveKey");
        localStorage.removeItem("chosedTabs");
        window.location.href="/"
    }
    /**
     * 删除cookie
     * @param name
     */
    static delCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ';path=/';//避免跨越iframe无法删除cookie
    }
    /**
     * 设置cookie
     * @param name
     * @param value
     */
    static setCookie(name, value) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
    }
    /**
     * 获取cookie
     * @param name
     * @returns {*}
     */
    static getCookie(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    }
    /**
     * 记住密码将登陆用户名和密码存入cookie
     * @param username
     * @param password
     * @param rememberMe
     */
    static addCookie(username, password, rememberMe) {
        if (rememberMe) {
            this.setCookie("username", username);
            this.setCookie("password", BASE64.encoder(hex_md5(password) + "@" + password));
        } else {
            this.setCookie("username", username);
            this.delCookie("password");
        }
    }
    static addStorage(username, rememberMe, organizationId, isOldLogin) {
        localStorage.setItem(wwConstants.localStorage.isOldLogin, isOldLogin);
        localStorage.setItem(wwConstants.localStorage.username, username);
        localStorage.setItem(wwConstants.localStorage.organizationId, organizationId);
        localStorage.setItem(wwConstants.localStorage.rememberMe, rememberMe);
    }
    /**
     * 记住密码将登陆用户名和密码存入cookie
     * @param usernameIMEI
     * @param passwordIMEI
     * @param rememberMeIMEI
     */
    static addCookieForIMEI(usernameIMEI, passwordIMEI, rememberMeIMEI) {
        if (rememberMeIMEI) {
            this.setCookie("usernameIMEI", usernameIMEI);
            this.setCookie("passwordIMEI", BASE64.encoder(hex_md5(passwordIMEI) + "@" + passwordIMEI));
        } else {
            this.setCookie("usernameIMEI", usernameIMEI);
            this.delCookie("passwordIMEI");
        }
    }

    /**
     * 获取API接口
     * */
    static getApiUrl(key){
        return key? restApis[key]:"";
    }
    /**
     * 去除空格
     * @param str
     */
    static trimStr(str) {
        return str.replace(/\s+/g, '');
    }

    /*--------------------------------业务接口----------------------*/
    /**
     * 获取历史工况详情
     * @param id
     * @param callback
     */
    static getHistoryWorkingCondition(id,callback){
        let url = this.getApiUrl("hisDetailDel");
        url+="?id="+id;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
               callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 实时工况详情获取
     * @param carId
     * @param callback
     */
    static getRealTimeWorkingConditions(carId,callback){
        let url = this.getApiUrl("realWorkingConditions");
        url += "?carId="+carId;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
               callback(data.data)
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 根据经纬度查询地址
     * @param lat
     * @param lng
     * @param callback
     */
    static getAddressDetail(lat,lng,callback){
        let coordinate = WWUtils.getOptionsFromGlobalEnums("enums.coordinate");
        let code = coordinate[0].value;
        let url = this.getApiUrl("addressDetail");
        url+=`?lat=${lat}&lng=${lng}&coordinate=${code}`;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
               callback(data.data)
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 日历控件操作
     * @param current
     * @param dates
     * @returns {boolean}
     */
    static disabledDate(current,dates){
        if (!dates) {
            return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'days') >= 31;
        const tooEarly = dates[1] && dates[1].diff(current, 'days') >= 31;
        return !!tooEarly || !!tooLate;
    }

    /**
     * 日历控件展开
     * @param open
     * @param callback1
     * @param callback2
     */
    static onOpenChange(open,callback1,callback2){
        if (open) {
            callback1();
        } else {
            callback2();
        }
    }

    /**
     * 获取历史工况条数
     * @param params
     * @param callback
     */
    static getHistoryWorkingConditionsCount(params,callback){
        let url = this.getApiUrl("hisCount");
        WWUtils.fetch(url,'POST',params,(data)=> {
            if(data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 获取历史工况列表
     * @param params
     * @param callback
     */
    static getHistoryWorkingConditionsList(params,callback){
        let url = this.getApiUrl("hisList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            if(data.code === 0) {
                callback(data.data)
            }else{
                message.error(data.message)
            }
        })
    }

    /**
     * 修改车型启用状态
     * @param params
     */
    static  switchVinTypeListItemStatus(params){
        let url = this.getApiUrl("switchVinTypeListItemStatus");
        WWUtils.fetch(url,'PUT',params,(data)=> {
           if(data.code === 0){
               message.success(Strings.optsuccess ||"操作成功");
           }else{
               message.error(data.message);
           }
        })
    }

    /**
     * 获取车型列表条数
     * @param params
     * @param callback
     */
    static  getVinTypelistCount(params,callback){
        let url = this.getApiUrl("vinTypeCount");
        WWUtils.fetch(url,'POST',params,(data)=> {
            if(data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 获取车型列表数据
     * @param params
     * @param callback
     */
    static  getVinTypeList (params,callback){
        let url = this.getApiUrl("vinTypeList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            if(data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 删除车型
     * @param record
     * @param callback
     */
    static delVinTypeItem(record,callback){
        let url = this.getApiUrl("delAddEditVinTypeItem");
        url += "?id="+record.id;
        WWUtils.fetch(url,'DELETE',(data)=> {
            if(data.code === 0) {
                message.success(Strings.optsuccess  || "操作成功");
                callback()
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 获取车型详情
     * @param id
     * @param callback
     */
    static  getVinTypeDetail(id,callback){
        let url = this.getApiUrl("delAddEditVinTypeItem");
        url+="?id="+id;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 获取车型全部字段
     * @param callback
     */
    static getAllVinParmas(machineType,callback){
        let url = this.getApiUrl("getVinTypeFAllParams");
        if(machineType){
            url += "?machineType="+machineType;
        }
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
               callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 保存车型参数
     * @param params
     */
    static saveVinParams(params,callback){
        let url = this.getApiUrl("delAddEditVinTypeItem");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback()
            if(data.code === 0) {
                message.success(Strings.optsuccess  || "操作成功");
            }else{
                message.error(data.message);
            }
        })
    }

    /**
     * 批量修改设备
     * @param fileName
     * @param callback
     */
    static bathModifyImeis(fileName,callback,callback1){
        let url = this.getApiUrl("batchModify");
        url += `?fileName=${fileName}`
        WWUtils.fetch(url,'POST',(res)=> {
            callback(res)
        },(error)=>{

        },(data)=>{
        //处理上传异常 TODO
            callback1(data)
        })
    }

    /**
     * 修改单个设备
     * @param params
     * @param callback
     */
    static modifyDevice(params,callback){
        let url = this.getApiUrl("addDelDetailDevice");
        WWUtils.fetch(url,'POST',params,(data)=> {
            if(data.code === 0) {
                callback(data)
            }else{
                message.error(data.message)
            }
        })
    }
    //获取设备详情
    static getDeviceDetail(imei,callback){
        let url = this.getApiUrl("addDelDetailDevice");
        url += `?id=${imei}`
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
                callback(data.data)
            }else{
                message.error(data.message);
            }
        })
    }
    //更新设备位置信息到列表里
    static updateAddressInList(keyParam,key,list,lat,lng,callback){
        WWUtils.getAddressDetail(lat,lng,(data)=>{
            let temp_list = JSON.parse(JSON.stringify(list));
            temp_list.map((item)=>{
                if(item[keyParam].toString() === key.toString()){
                    item.address = data;
                }
                return item;
            })
            callback(temp_list)
        })
    }
    /**
     * 获取设备型号列表
     * */
    static getDeviceTypes(callback) {
        let url = this.getApiUrl("deviceTypes");
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else{
                message.error(data.message);
            }
        })
    }
    //获取设备生命周期
    static getDeviceLiftCycle(params,callback){
        let url = this.getApiUrl("deviceLifeCycle");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else{
                message.error(data.message);
            }
        })
    }
    //获取设备状态对应的样式className
    static getDeviceStatusClass(status){
        const color ={
            "120":"green",
            "10":"gray",
            "20":"gray"
        }
        return status && color[status.toString()]?color[status.toString()]:""
    }
    //查询未绑定车辆的设备
    static getAvilableDevice(imei,orgId,callback){
        let url = this.getApiUrl("avilableDeive");
        url += `?imei=${imei}&orgId=${orgId}`;
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message)
            }
        })
    }
    //新增或者修改车辆信息
    static saveVinInfo(params,callback){
        let url = this.getApiUrl("vinDetailDelAdd");
        WWUtils.fetch(url, 'POST',params, (data) => {
            callback()
            if (data.code === 0) {
               message.success(Strings.optsuccess || "操作成功");
            }else{
                message.error(data.message)
            }
        })
    }
    //获取支持的车辆类型数据,数据做缓存处理
    static getVinModels (organizationId,callback){
        let url = WWMethods.getApiUrl("vinModelList");
        url+="?orgId="+organizationId;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }
    //生成车型列表下拉框
    static formatVinTypeOptions  (vinTypeList){
        return vinTypeList?vinTypeList.map((type_item)=>{
            let imageurl = WWUtils.getIconIDURLMap(type_item.iconCode)
            return <Option key={type_item.id} value={type_item.id}><span className={"optionIcons"} title={type_item.name}><img className={"icon"} src={imageurl}></img>{type_item.name}</span></Option>
        }):null;
    }

    /**
     * 获取车辆详情
     * @param carId
     * @param callback
     */
    static getCarInfo(carId,callback){
        let url = this.getApiUrl("vinDetailDelAdd");
        url += "?id="+carId;
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
               callback(data.data)
            }else{
                message.error(data.message)
            }
        })
    }
    /*获取车辆维护记录*/
    static getCarDeviceLog(params,callback){
        let url = this.getApiUrl("vinImeilog");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else{
                message.error(data.message)
            }
        })
    }
    //批量和单个转移车辆
    static transferVins(params,callback){
        let url = this.getApiUrl("vinTransfer");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
               callback(data);
            }else{
                message.error(data.message)
            }
        })
    }
    //批量转移车辆，添加时校验
    static transferVinCheck(params,callback){
        let url = this.getApiUrl("vinTransferCheck");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message)
            }
        })
    }

    //全局搜索
    static getGlobalSearchList(content,count,callback){
        let url = this.getApiUrl("globalSearch");
        url += `?content=${content}&count=${count}`
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message)
            }
        })
    }
    //创建导出任务
    static downloadVinList(params,callback){
        let url = this.getApiUrl("createTask");
        WWUtils.fetch(url, 'POST',params, (data) => {
           callback(data)
        })
    }
    //导出任务数量统计
    static getExportTaskCount(params,callback){
        let url = this.getApiUrl("exportTaskCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    //导出任务list
    static getExportTaskList(params,callback){
        let url = this.getApiUrl("exportTaskList");
        WWUtils.fetch(url, 'POST',params, (data) => {
            callback(data);
        })
    }
    //导出任务重试
    static getExportTaskRetry(taskId,callback){
        let url = this.getApiUrl("taskRetry");
        url+= "?taskId="+taskId;
        WWUtils.fetch(url, 'GET', (data) => {
            if(data.code === 0) {
                message.success(Strings.optsuccess  || "操作成功");
                callback()
            }else {
                message.error(data.message)
            }
        })
    }
    //查询指令模板
    static getCmdTemplate(imei,callback){
        let url = this.getApiUrl("cmdTpls");
        url+= "?imei="+imei;
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else{
                message.error(data.message);
            }
        })
    }
    //指令记录数量统计
    static getImeiDirectiveCount(params,callback){
        let url = this.getApiUrl("cmdCount");
        WWUtils.fetch(url, 'POST', params,(data) => {
           callback(data);
        })
    }
    //指令记录记录
    static getImeiDirectiveList(params,callback){
        let url = this.getApiUrl("cmdList");
        WWUtils.fetch(url, 'POST', params,(data) => {
            callback(data);
        })
    }
    //发送指令
    static sendDirective(params,callback){
        let url = this.getApiUrl("sendCmd");
        WWUtils.fetch(url, 'POST', params,(data) => {
            callback(data);
        })
    }
    //查询指令发送状态
    static checkDirectiveStatus(historyId,callback){
        let url = this.getApiUrl("addModifyDelDetailCmd");
        url+="?historyId="+historyId;
        WWUtils.fetch(url, 'GET',(data) => {
            callback(data);
        })
    }
    //获取工时统计列表
    static getWorkTimeStatisticsList(params,callback){
        let url = WWMethods.getApiUrl("workTimeList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //获取ACC统计列表
    static getAccStatisticsList(params,callback){
        let url = WWMethods.getApiUrl("accStatisticsList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //获取ACC统计总数及列表
    static getAccStatisticsSummaryCount(params,callback){
        let url = WWMethods.getApiUrl("accStatisticsSummaryCount");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getAccStatisticsSummaryList(params,callback){
        let url = WWMethods.getApiUrl("accStatisticsSummaryList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //获取运行统计列表
    static getRunStatisticsList(params,callback){
        let url = WWMethods.getApiUrl("runStatisticsList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //获取运行统计总数
    static getRunStatisticsCount(params,callback){
        let url = WWMethods.getApiUrl("runStatisticsCount");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //获取开工明细总数
    static getRunStatisticsWorkDetailCount(params,callback){
        let url = WWMethods.getApiUrl("runStatisticsWorkDetailCount");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //获取开工明细列表
    static getRunStatisticsWorkDetailList(params,callback){
        let url = WWMethods.getApiUrl("runStatisticsWorkDetailList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    //删除导出任务
    static delExportTask(taskId,callback){
        let url = this.getApiUrl("delExportTask");
        url += "?taskId="+taskId;
        WWUtils.fetch(url,'DELETE',(data)=> {
            if(data.code === 0) {
                message.success(Strings.optsuccess  || "操作成功");
                callback()
            }else {
                message.error(data.message)
            }
        })
    }
    static getAlarmSummaryList(params,callback){
        let url = WWMethods.getApiUrl("alarmSummaryList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getAlarmSummaryCount(params,callback){
        let url = this.getApiUrl("alarmSummaryCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    //叉车故障统计
    static getForkliftStatisticsSummaryList(params,callback){
        let url = WWMethods.getApiUrl("forkliftStatisticsSummaryList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getForkliftStatisticsSummaryCount(params,callback){
        let url = this.getApiUrl("forkliftStatisticsSummaryCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    static getForkliftStatisticsDetailList(params,callback){
        let url = WWMethods.getApiUrl("forkliftStatisticsDetailList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getForkliftStatisticsDetailCount(params,callback){
        let url = this.getApiUrl("forkliftStatisticsDetailCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    //故障统计
    static getFailureStatisticsSummaryList(params,callback){
        let url = WWMethods.getApiUrl("failureStatisticsSummaryList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getFailureStatisticsSummaryCount(params,callback){
        let url = this.getApiUrl("failureStatisticsSummaryCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    static getFailureStatisticsDetailList(params,callback){
        let url = WWMethods.getApiUrl("failureStatisticsDetailList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getFailureStatisticsDetailCount(params,callback){
        let url = this.getApiUrl("failureStatisticsDetailCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    static getAlarmDetailList(params,callback){
        let url = WWMethods.getApiUrl("alarmDetailList");
        WWUtils.fetch(url,'POST',params,(data)=> {
            callback(data)
        })
    }
    static getAlarmDetailCount(params,callback){
        let url = this.getApiUrl("alarmDetailCount");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                callback(data.data);
            }else {
                message.error(data.message)
            }
        })
    }
    static handleAlarm(params,callback){
        let url = this.getApiUrl("alarmHandle");
        WWUtils.fetch(url, 'POST',params, (data) => {
            callback(data)
        })
    }
    //获取围栏信息
    static getAlarmFence(record,callback){
        let url = this.getApiUrl("alarmFence");
        url+="?fenceId="+record.extInfoBean.id;
        url+="&imei="+record.imei;
        url+="&alarmTime="+record.alarmTime;
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else {
                message.error(data.message)
            }
        })
    }

    static getFenceAlarmDetail(fenceId,imei,alarmTime,coordinate,callback){
        let url = this.getApiUrl("alarmFence");
        url+= "?fenceId="+fenceId +'&imei='+imei + '&alarmTime='+alarmTime + '&coordinate='+coordinate;
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else {
                message.error(data.message)
            }
        })
    }
    static getDistanceUnit(callback){
        let url = this.getApiUrl("getDistanceUnit");
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else {
                message.error(data.message)
            }
        })
    }
    static getAccountInfo(callback){
        let url = this.getApiUrl("accountInfo");
        WWUtils.fetch(url, 'GET', (data) => {
            if (data.code === 0) {
                callback(data.data)
            }else {
                message.error(data.message)
            }
        })
    }
    //保存权限配置
    static savePermissionConfig(params){
        let url = this.getApiUrl("savePermissionConfig");
        WWUtils.fetch(url, 'POST',params, (data) => {
            if (data.code === 0) {
                message.success(Strings.rs10360 || "数据保存成功"); 
            }else {
                message.error(data.message)
            }
        })
    }
   

    //删除权限配置项
    static delPermissionItem(record,callback){
        let url = this.getApiUrl("delPermissionConfigItem");
        url += record.userId;
        WWUtils.fetch(url,'DELETE',(data)=> {
            if(data.code === 0) {
                message.success(Strings.optsuccess  || "操作成功");
                callback()
            }else{
                message.error(data.message);
            }       
        })
    }
    //获取账号权限配置树
    static getPermissonsByAccount(id,userId,callback){
        let url = this.getApiUrl("getPermissonsByAccount");
        url += id;
        if (userId) {
            url += "&userId=" + userId;
        }
        WWUtils.fetch(url, 'GET', (data) => {
            callback(data)
        })
    }
    //获取账号列表
    static getUserListByOrgId(organizationId,callback){
        let url = this.getApiUrl("getAccountList");
        url += `${organizationId}`;
        WWUtils.fetch(url, 'GET', (data) => {
            callback(data);
        })
    }
    //权限配置开关
    static editPermissionSwitch(params,callback){
        let url = this.getApiUrl("editSwitch"); 
        WWUtils.fetch(url, 'PUT', params,(data) => {
            if (data.code === 0) {
                message.success(Strings.optsuccess  || "操作成功");
                callback()
            }else {
                message.error(data.message)
            }       
        })
    }
}
